import { useState, useEffect } from "react";
import PropTypes from 'prop-types'
import mixpanel from "mixpanel-browser";

// Stripe
import { getCheckoutUrl } from "../../config/stripe-config";

// Redux
import { connect } from 'react-redux';

// Global Functions
import { handleDownload_Apple } from "../../actions/downloadActions";

// Imgs
import apple_logo from './AppleLogo';

const DownloadBtn_Apple = ({
    fullWidth,
    auth: {
        isAuthenticated,
        isPremium
    }
}) =>  {

    const [processing, setProcessing] = useState(false);

    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
            
    useEffect(() => {
            
        // Add event listener for window resize
        window.addEventListener('resize', () => handleWindowSizeChange());
    
        // Cleanup the event listener when the component unmounts
        return () => window.removeEventListener('resize', () => handleWindowSizeChange());
    }, []);
    
    // Update window width state on window resize
    const handleWindowSizeChange = () => {
        setWindowWidth(window.innerWidth);
    };

    // Check if the device is mobile or tablet
    const isMobile = windowWidth <= 769;
    const isTablet = windowWidth <= 1024;

    const handleClick = async () => {
        try {
            if(isPremium) {
                setProcessing(true);
                // Download file
                handleDownload_Apple();
                setTimeout(() => {
                    setProcessing(false);
                }, 2000);
            } else {
                await upgradeToPremium();
            }
        } catch (error) {
            console.log('Something went wrong');
            console.log(error);
        } finally {
            // ---- SEND TO MIXPANEL ----

            if (process.env.NODE_ENV === 'production') {
                mixpanel.track("Clicked Download Apple");
            }

            // ---- END: SEND TO MIXPANEL ----
        }
    }

    const upgradeToPremium = async () => {

        if(!isAuthenticated) {
            window.location.href = '/signup';
            return;
        }

        setProcessing(true);

        try {
            let priceId = 'price_1RCl12DsLplMK070ZzZ2pTLg'; // Monthly subscription ID
            const checkoutUrl = await getCheckoutUrl(priceId);
            window.location.href = checkoutUrl;
            console.log('redirected');
        } catch (error) {
            console.log('ERROR GETTING CHECKOUT LINK');
            // console.log(error)
            alert('Something Went Wrong. Please logout and try again.')
        } finally {
            setProcessing(false);
        }
    }

	return (
        <button
            onClick={() => handleClick()} 
            style={{boxShadow: '0 0 20px rgba(255, 191, 0, .3)', background: '#FFFF00', color: '#000', fontWeight: 'bold', fontSize: '.875rem', width: `${(fullWidth || isMobile) ? '100%' : 'fit-content'}`, marginLeft: 'auto', padding: '.5rem 1.5rem .5rem 1.5rem', borderRadius: '14px', border: 'none', cursor: 'pointer'}}
            disabled={processing} 
        >
            <div style={{display: 'flex', gap: '.5rem', alignItems: 'center', justifyContent: 'center'}}>
                <img alt="Apple" loading="lazy" width="20" height="20" decoding="async" src={apple_logo} style={{borderRadius: '50%', width: '1.25rem', height: '1.25rem'}} />
                {processing ? 'Processing...' : 'Download for Mac'}
            </div>
        </button>
	);
}

DownloadBtn_Apple.propTypes = {
    auth: PropTypes.object.isRequired,
}

const mapStateToProps = state => ({
    auth: state.auth
})

export default connect(mapStateToProps, null)(DownloadBtn_Apple);
  